import { RESERVATION_TYPE } from '../constants/travel-reservation.enum';
import { TravelReservation_Additional_Props } from './travel-reservation-additional-interface';
import { TravelReservation_Passenger } from './travel-reservation-passenger-interface';
import {
  Errors,
  TravelReservation_Arrival,
  TravelReservation_Carrier,
  TravelReservation_Origin,
  TravelReservation_Reservation_BookingRef,
  TravelReservation_Segment_Leg,
  TravelReservation_Transport_Station
} from './travel-reservation-support-interface';
export interface TravelReservation_Reservation
  extends TravelReservation_Additional_Props {
  bookingReferences: TravelReservation_Reservation_BookingRef[];
  type: RESERVATION_TYPE;
  cartId?: string;
  vendorId?: string;
  nonrefundable?: boolean;
  bookingCreationDt?: string;
  ticketExpirationDt?: string;
  corporateBooking?: boolean;
  ticketed?: boolean;
  skyPriority?: boolean;
  tripType?: string;
  international?: boolean;
  checkinEligible?: boolean;
  standbyEligible?: boolean;
  emailProvided?: boolean;
  emailRefused?: boolean;
  companionBooking?: boolean;
}

export interface TravelReservation_Trip_Segment {
  actionCode: string;
  segmentId: number;
  ordinal: number;
  marketingSegment: {
    operationalSuffix: string;
    fareBasisCode?: string;
    flightNum: string;
    carrier: TravelReservation_Carrier[];
  };
  operatingCarrier?: TravelReservation_Carrier[];
  legs: TravelReservation_Segment_Leg[];
  stops: string;
  changeOfGauge: boolean;
  throughFlight: boolean;
  operationalStatus?: {
    type: string;
    subType: string;
    flightNumChange: boolean;
    rebookEligible?: boolean;
  };
  checkedIn: boolean;
  upgradeWaitlisted?: boolean;
  redEye: boolean;
  misconnect: boolean;
  originStation: TravelReservation_Transport_Station;
  standbyEligible: boolean;
  destinationStation: TravelReservation_Transport_Station;
  flightSegmentId?: string;
}

export interface TravelReservation_Trip {
  tripId: number;
  ordinal: number;
  transportOrigin: TravelReservation_Origin;
  transportDestination: TravelReservation_Arrival;
  segments: TravelReservation_Trip_Segment[];
  international: boolean;
  checkinEligible: boolean;
  standbyEligible: boolean;
  iropProtect?: IropProtectFlags;
  distanceMiles?: number;
  bookedTripLegKey?: string;
}

export interface TravelReservationRequest {
  using: string;
  loyaltyNum?: string;
  confirmationNum?: string;
  givenNames: string;
  surname: string;
}

export interface TravelReservationResponse {
  reservationResourceId: string;
  reservation: TravelReservation_Reservation;
  passengers: TravelReservation_Passenger[];
  trips: TravelReservation_Trip[];
}

export interface TravelReservation {
  travelReservationRequest: TravelReservationRequest;
  travelReservations: TravelReservationResponse[];
  errors?: Errors[];
}

export interface LayoverDataAckModal {
  layoverTime: string;
}

export interface IropProtectFlags {
  protect: boolean;
  tripId: number;
  iropTripId: string;
}

export interface SearchRequest {
  recordLocator: string;
  firstName: string;
  lastName: string;
  app?: string;
  searchType?: string;
}

export interface SearchRequestPax extends SearchRequest {
  passengerResourceId?: string;
}
